export default "__VITE_ASSET__DUQliy3b__"